import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {

  transform(value: any, format: string = "DD/MM/YYYY"): string {
    return moment(value).format(format);
  }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/pipes/date-format.pipe.ts